function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/ React.createElement("path", {
    d: "M497.778 0L1024 526.222V1024L0 0h497.778z",
    fill: "#E94D3D"
});
var _ref2 = /*#__PURE__*/ React.createElement("path", {
    d: "M512 108.089l21.333 21.333-42.666 180.622L603.022 197.69l22.756 22.755-156.445 159.29L448 358.4l42.667-180.622L378.31 290.133l-22.755-25.6L512 108.09zm152.178 150.755l98.133 98.134-22.755 21.333-73.956-73.955-45.511 45.51 62.578 62.578-21.334 21.334-64-64L550.4 416.71l73.956 73.956-22.756 22.755-98.133-98.133 160.71-156.445zm109.51 109.512l24.179 24.177-88.178 136.534 142.222-82.49 17.067 17.067-82.49 140.8 136.534-88.177 24.178 24.177-196.267 119.467L731.023 640l83.91-142.222-142.222 83.91-18.489-17.066L773.69 368.356z",
    fill: "currentColor"
});
function SvgNew(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        className: "new_svg__icon",
        width: "1em",
        height: "1em",
        viewBox: "0 0 1024 1024"
    }, props), _ref, _ref2);
}
export default SvgNew;
